import avatars from '../config/avatars';
import { makeClassName } from '@siteless/util';
import { CurrentUserResourceType } from '../resources/Auth/CurrentUser';
import { UserProfileType } from '../resources/userProfileSchema';
import LetterboxdIcon from './LetterboxdIcon';
import CrownIcon from './CrownIcon';

export let UserListItem = ({
  user,
  isComplete,
  isCurrentUser,
  isOwner,
  onClick,
  className,
}: {
  user: CurrentUserResourceType | UserProfileType;
  isComplete: boolean;
  isCurrentUser: boolean;
  isOwner?: boolean;
  onClick?: () => void;
  className?: string;
}) => {
  const ArtworkComponent =
    avatars[user.avatarId || 'AVATAR_0'].ArtworkComponent;

  return (
    <div
      className={makeClassName(
        className,
        'relative flex flex-col items-center',
      )}
      onClick={onClick}
    >
      <div
        className={makeClassName(
          'mb-2 h-28 w-28 rounded-full border-4 p-1',
          isCurrentUser && 'border-rose-bright',
          !isComplete && 'border-neutral-0 opacity-75',
        )}
      >
        <ArtworkComponent
          className="h-full w-full"
          backgroundColor={user.avatarBackgroundHex || undefined}
        />
      </div>
      <div className="max-w-xs overflow-hidden truncate">
        {user.handle}
        {isOwner && (
          <CrownIcon className="ml-1 inline-block h-4 w-4 text-neutral-400" />
        )}
        {user.letterboxdId && (
          <LetterboxdIcon className="ml-1 inline-block h-4 w-4 text-neutral-400" />
        )}
      </div>
    </div>
  );
};
